import { createFileRoute, Outlet } from '@tanstack/react-router';
import NotesView from '../components/NotesView';
import { validateListPageSearch } from '../utils/listPageSearch';

export const Route = createFileRoute('/_app/notes')({
  validateSearch: validateListPageSearch,
  component: NotesLayout,
});

// The list + reader live in this layout route so they stay mounted while the
// reader opens at /notes/read/$id — the list keeps its scroll position and the
// reader stays scoped to Notes (its own "folder"), never jumping to Home.
function NotesLayout() {
  const search = Route.useSearch();
  const page = search.page ?? 1;
  const navigate = Route.useNavigate();
  const readerHighlightId = search.highlight;

  const updatePageSearch = (nextPage: number) => {
    const safePage = Math.max(1, nextPage);
    navigate({
      replace: true,
      search: (prev) => {
        if (safePage <= 1) {
          if (prev.page === undefined) return prev;
          const { page: _page, ...rest } = prev;
          return rest;
        }
        if (prev.page === safePage) return prev;
        return { ...prev, page: safePage };
      },
    });
  };

  return (
    <>
      <NotesView
        page={page}
        onPageChange={updatePageSearch}
        readerHighlightId={readerHighlightId}
      />
      <Outlet />
    </>
  );
}
